module.exports = __webpack_public_path__ + "img/supplier.a8ffad2f.svg";